import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserActivityService {

  private inactivityLimit = 45 * 60 * 1000; // 45 minutos
  private lastActivityTime = Date.now();
  private checkInterval: any = null;

  private events = ['mousemove', 'keydown', 'click', 'scroll', 'focus', 'blur'];

  private activityHandler = () => {
    this.lastActivityTime = Date.now();
    console.log("El usuario tubo actividad");
  };

  startWatching(lastUrl: string) {
    this.lastActivityTime = Date.now();

    this.events.forEach(event => {
      window.addEventListener(event, this.activityHandler);
    });

    this.checkInterval = setInterval(() => {
      const now = Date.now();
      const diff = now - this.lastActivityTime;

      if (diff >= this.inactivityLimit) {
        this.stopWatching();
        window.location.href =
          '/notfoundpage?fromUrl=' + encodeURIComponent(lastUrl);
      }
    }, 5000);
  }

  stopWatching() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }

    this.events.forEach(event => {
      window.removeEventListener(event, this.activityHandler);
    });
  }
}